<template>
  <div class="content">
    <el-tabs v-model="tabName">
      <el-tab-pane label="用户概览" name="first">
        <div class="info-list">
          <span>累计注册：{{userData.registerTotal}}</span>
          <span>活跃店铺：{{userData.bindStoreTotal}}</span>
          <span>shopify店铺累计：{{userData.shopifyBindStoreTotal}}</span>
          <span>shoplazza店铺累计：{{userData.shoplazzaBindStoreTotal}}</span>
          <span>shopline店铺累计：{{userData.shoplineBindStoreTotal}}</span>
          <span>woocommerce店铺累计：{{userData.woocommerceBindStoreTotal}}</span>
          <span>commentSold店铺累计：{{userData.commentSoldBindStoreTotal}}</span>
          <span>tiktok店铺累计：{{userData.tiktokBindStoreTotal}}</span>
          <span>temu店铺累计：{{userData.temuBindStoreTotal}}</span>
          <p style="margin-top:10px;">
            <span>累计总订单数：{{userData.orderTotal}}</span>
            <span>累计订单总金额：${{userData.orderAmountTotal}}</span>
            <span>已付款订单总金额: ${{userData.orderPaymentAmountTotal}}</span>
          </p>
        </div>
        <div class="filter" style="margin-top:10px;">
          <el-select v-model="userTotalForm.storeGroup" placeholder="用户分组" clearable @change="resetPage">
            <el-option v-for="item in group" :label="item.name" :key="item.code" :value="item.code"></el-option>
          </el-select>
          <el-date-picker v-model="registerDate" type="daterange" align="right" unlink-panels range-separator="至" start-placeholder="开始日期" end-placeholder="结束日期" :picker-options="pickerOptions" :default-time="['00:00:00', '23:59:59']" value-format="timestamp" @change="handleDatePick"></el-date-picker>
          <span class="update-time">更新时间：{{userData.modifyDate}}</span>
          <!-- <el-button>重新统计</el-button> -->
          <el-button @click="exportUserTotal">数据导出</el-button>
          <el-button @click="exportOrderDetail">订单明细导出</el-button>
          <el-button @click="showDialog">列表字段配置</el-button>
        </div>

        <el-table :data="userList" @sort-change="sortTotalTable" height="calc(100vh - 320px)">
          <el-table-column sortable="custom" label="日期" min-width="130" prop="period">
            <template slot-scope="{row,$index}">
              <span>{{$index===0?"总计":sliceString(row.period) }}</span>
            </template>
          </el-table-column>
          <el-table-column sortable="custom" prop="activeUserDaily" label="日活跃用户" min-width="120"></el-table-column>
          <el-table-column sortable="custom" prop="registerDaily" label="新增注册" min-width="120"></el-table-column>
          <el-table-column v-for="(item,index) in columns" :key="index" sortable="custom" :prop="item.value" :label="item.title" min-width="210">
            <template slot-scope="{row}">
              <span> <span v-show="item.title.indexOf('金额')>-1">$</span> {{row[item.value]}}</span>
            </template>
          </el-table-column>
        </el-table>

        <div class="f-b-c bg-white" style="padding: 10px">
          <div></div>
          <el-pagination background :current-page="userTotalForm.pageNumber" :page-sizes="[20, 50, 100, 200, 500]" :page-size="userTotalForm.pageSize" layout="total, sizes, prev, pager, next, jumper" :total="total" class="el-pagination" @size-change="handleTotalSizeChange" @current-change="pageChange" />
        </div>
      </el-tab-pane>

      <el-tab-pane label="用户明细" name="second">
        <div class="filter">
          <el-input placeholder="请输内容" v-model="filterValue" class="filter-input"  style="width:350px;"  clearable @change="changeType" >
            <el-select v-model="filterType" slot="prepend" placeholder="请选择" style="width:130px;" @change="changeFilterType" >
              <el-option label="用户名" value="1"></el-option>
              <el-option label="邮箱/手机号" value="2"></el-option>
            </el-select>
          </el-input>
          <el-select v-model="userDetailForm.isAuthentication" clearable placeholder="是否认证" style="width:120px;" @change="initPage">
            <el-option label="未认证" :value="0" />
            <el-option label="已认证" :value="1" />
          </el-select>
          <el-select v-model="userDetailForm.userGroup" placeholder="用户分组"  style="width:120px;" clearable @change="initPage">
            <el-option v-for="item in group" :label="item.name" :key="item.code" :value="item.code"></el-option>
          </el-select>
          <!-- <el-select v-model="userDetailForm.userManager" clearable placeholder="对接人" @change="initPage" multiple>
            <el-option v-for="(item,index) in userManager" :key="index" :value="item.userId" :label="item.fullName" />
          </el-select> -->
          <el-select v-model="userDetailForm.paramType" placeholder="请选择" style="width: 140px;" @change="initPageByRange">
            <el-option label="绑定店铺数" value="1"></el-option>
            <el-option label="上架产品店铺数" value="2"></el-option>
            <el-option label="出单店铺数" value="3"></el-option>
          </el-select>
          <span class="range-num f">
            <el-input style="width:100px" v-model="userDetailForm.paramStart" @blur="initPageByRange" clearable></el-input>~<el-input v-model="userDetailForm.paramEnd" clearable style="width:100px" @blur="initPageByRange"></el-input>
          </span>
          <el-date-picker :picker-options="pickerOptions" v-model="detailDate" type="daterange" range-separator="至" start-placeholder="开始日期" end-placeholder="结束日期" value-format="timestamp" :default-time="['00:00:00', '23:59:59']" @change="handleDetailDatePick"></el-date-picker>
        </div>
        <div class="filter f-b-c">
          <span class="update-time">更新时间：{{this.userdetailModifyDate}}</span>
          <div>
            <!-- <el-button>重新统计</el-button> -->
            <el-button @click="exportDetailTotal">数据导出</el-button>
          </div>
        </div>

        <el-table :data="userDetailList" @sort-change="sortDetailTable" height="calc(100vh - 322px)">
          <el-table-column sortable="custom" prop="registerDate" label="注册时间" min-width="180"></el-table-column>
          <el-table-column prop="fullName" label="用户名称" min-width="150"></el-table-column>
          <el-table-column prop="email" label="邮箱/手机号" :show-overflow-tooltip="true" min-width="200">
            <template slot-scope="{row}">
              <span>{{row.email}}</span>
              {{ row.email && row.phone ? '/' : '' }}
              <span>{{row.phone}}</span>
            </template>
          </el-table-column>
          <el-table-column prop="referrer" label="注册来源" :show-overflow-tooltip="true" min-width="150"></el-table-column>
          <el-table-column prop="isAuthentication" label="是否认证">
            <template slot-scope="{row}">
              <span>{{row.isAuthentication===0?'未认证':'已认证'}}</span>
            </template>
          </el-table-column>
          <el-table-column prop="userManager" label="对接人"></el-table-column>
          <el-table-column sortable="custom" prop="bindStoreTotal" label="绑定店铺数" min-width="120">
            <template slot-scope="{row}">
              <el-popover v-if="row.bindStoreList" placement="bottom-start"  width="200" trigger="hover" >
                <span class="pointer" slot="reference">{{row.bindStoreTotal}}</span>
                <div v-for="(item,index) in row.bindStoreList" :key="index">{{Object.keys(item)[0]}}:
                  <span v-for="(x,y) in item[Object.keys(item)[0]]" :key="y">{{x}}</span>
                </div>
              </el-popover>
              <span v-else>{{row.bindStoreTotal}}</span>
            </template>
          </el-table-column>
          <el-table-column sortable="custom" prop="publishStoreTotal" label="上架产品店铺数" min-width="150"></el-table-column>
          <el-table-column sortable="custom" prop="publishListingTotal" label="上架产品数" min-width="120"></el-table-column>
          <el-table-column sortable="custom" prop="orderStoreTotal" label="出单店铺数" min-width="120"></el-table-column>
          <el-table-column sortable="custom" prop="orderTotal" label="订单总数" min-width="120"></el-table-column>
          <el-table-column sortable="custom" prop="orderAmountTotal" label="订单总金额" min-width="120"></el-table-column>
        </el-table>

        <div class="f-b-c bg-white" style="padding: 10px">
          <div></div>
          <el-pagination background :current-page="userDetailForm.pageNumber" :page-sizes="[20, 50, 100, 200, 500]" :page-size="userDetailForm.pageSize" layout="total, sizes, prev, pager, next, jumper" :total="detailTotal" class="el-pagination" @size-change="handleDetailSizeChange" @current-change="DetailPageChange" />
        </div>
      </el-tab-pane>
    </el-tabs>
    <el-dialog title="列表字段配置" :visible.sync="visible" width="800px" @close="close" :close-on-click-modal="false">
      <el-checkbox :indeterminate="isIndeterminate" v-model="checkAll" @change="handleCheckAllChange">全选</el-checkbox>
      <div style="margin: 15px 0;"></div>
      <el-checkbox-group v-model="checkList" @change="handleCheckedCitiesChange">
        <el-checkbox style="width:20%;margin-bottom:10px" v-for="(item,index) in columnTitles" :key="index" :label="item.value">{{item.title}}</el-checkbox>
      </el-checkbox-group>
      <span slot="footer" class="dialog-footer">
        <el-button @click="close">取 消</el-button>
        <el-button type="primary" @click="save">保存</el-button>
      </span>
    </el-dialog>
  </div>
</template>

<script>
import API from '@/api'
import _ from 'lodash'
import { dateFormat } from '@/utils/date'
export default {
  name: 'report_userStatistics',
  data() {
    return {
      tabName: 'first',
      total: 0,
      visible: false,
      detailTotal: 0,
      registerDate: [Date.now() - 29 * 24 * 3600000, Date.now()],

      detailDate: undefined,
      configId: undefined,
      userList: [], // 用户列表
      userDetailList: [], // 用户明细列表
      group: [], // 用户分组列表
      selected: [], // 所有已选项
      userDetailForm: {
        pageNumber: 1,
        pageSize: 20,
      },
      filterValue: '',
      filterType: '',
      userTotalForm: {
        pageNumber: 1,
        pageSize: 20,
      },
      roleForm: {
        roleList: [10]
      },
      isIndeterminate: true,
      checkAll: false,
      show: false,
      userManager: [],//对接人列表
      userdetailModifyDate: '',
      userData: {},
      exportForm: {},
      pickerOptions: {
        shortcuts: [{
          text: '今天',
          onClick(picker) {
            const end = new Date();
            const start = new Date();
            start.setTime(start.setHours(0, 0, 0, 0), start.setHours(23, 59, 59, 999));
            picker.$emit('pick', [start, end]);
          }
        }, {
          text: '昨天',
          onClick(picker) {
            const end = new Date().setHours(23, 59, 59, 999) - 24 * 3600000;
            const start = new Date().setHours(0, 0, 0, 0) - 24 * 3600000;
            picker.$emit('pick', [start, end]);
          }
        }, {
          text: '最近七天',
          onClick(picker) {
            const end = new Date();
            const start = new Date();
            start.setTime(start.getTime() - 3600 * 1000 * 24 * 6);
            picker.$emit('pick', [start, end]);
          }
        }, {
          text: '最近15天',
          onClick(picker) {
            const end = new Date();
            const start = new Date();
            start.setTime(start.getTime() - 3600 * 1000 * 24 * 14);
            picker.$emit('pick', [start, end]);
          }
        }, {
          text: '最近30天',
          onClick(picker) {
            const end = new Date();
            const start = new Date();
            start.setTime(start.getTime() - 3600 * 1000 * 24 * 29);
            picker.$emit('pick', [start, end]);
          }
        }, {
          text: '上个月',
          onClick(picker) {
            const start = new Date(new Date().getFullYear(), new Date().getMonth() - 1, 1).getTime();
            const end = new Date(new Date().getFullYear(), new Date().getMonth(), 0).getTime() + 24 * 3600000 - 60;
            picker.$emit('pick', [start, end]);
          }
        }],
        disabledDate(time) {
          return time.getTime() > new Date().setHours(23, 59, 59, 999);
        },
      },
      columns: [
        { title: '新增绑定店铺数', value: 'bindStoreDaily', check: true },
        { title: '上架产品店铺数 ', value: 'publishStoreDaily', check: true },
        { title: '上架产品数 ', value: 'publishListingDaily', check: true },
        { title: '出单店铺数', value: 'orderStoreDaily', check: true },
        { title: '订单总数', value: 'orderDaily', check: true },
        { title: '订单总金额', value: 'orderAmountDaily', check: true },
        { title: '已付款订单总金额', value: 'orderPaymentAmountDaily', check: true },
      ],
      checkList: [],
      columnTitles: [
        { title: '新增绑定店铺数', value: 'bindStoreDaily', check: true },
        { title: '上架产品店铺数 ', value: 'publishStoreDaily', check: true },
        { title: '上架产品数 ', value: 'publishListingDaily', check: true },
        { title: '出单店铺数', value: 'orderStoreDaily', check: true },
        { title: '订单总数', value: 'orderDaily', check: true },
        { title: '订单总金额', value: 'orderAmountDaily', check: true },
        { title: '已付款订单总金额', value: 'orderPaymentAmountDaily', check: true },
        { title: 'Kakaclo已付款金额', value: 'orderKkPaymentAmountDaily', check: false },
        { title: 'shopify已付款总金额', value: 'orderSpPaymentAmountDaily', check: false },
        { title: 'shoplazza已付款总金额', value: 'orderDjPaymentAmountDaily', check: false },
        { title: 'shopline已付款总金额', value: 'orderSlPaymentAmountDaily', check: false },
        { title: 'woocommerce已付款总金额', value: 'orderWcPaymentAmountDaily', check: false },
        { title: 'commentSold已付款总金额', value: 'orderCsPaymentAmountDaily', check: false },
        { title: 'tiktok已付款总金额', value: 'orderTtPaymentAmountDaily', check: false },
        { title: 'temu已付款总金额', value: 'orderPdPaymentAmountDaily', check: false },
        { title: '停用店铺数', value: 'deactivateStoreDaily', check: false },
      ],
      backUpColumn: []
    }
  },
  watch: {
    show(value) {
      if (value) {
        this.$message.error('当前日期不可选')
      }
    }
  },
  computed: {
    getSortType() {
      return (type) => {
        switch (type) {
          case 'ascending':
            return 1
          case 'descending':
            return 2
          case null:
            return 1
        }
      }
    },
    getUserTotalSortName() {
      return (name) => {
        switch (name) {
          case 'reportDate':
            return 1
          case 'activeUserDaily':
            return 2
          case 'registerDaily':
            return 3
          case 'bindStoreDaily':
            return 4
          case 'publishStoreDaily':
            return 5
          case 'publishListingDaily':
            return 6
          case 'orderStoreDaily':
            return 7
          case 'orderDaily':
            return 8
          case 'orderAmountDaily':
            return 9
          case 'orderPaymentAmountDaily':
            return 10
          case 'deactivateStoreDaily':
            return 11
          case 'orderKkPaymentAmountDaily':
            return 12
          case 'orderSpPaymentAmountDaily':
            return 13
          case 'orderDjPaymentAmountDaily':
            return 14
          case 'orderSlPaymentAmountDaily':
            return 15
          case 'orderWcPaymentAmountDaily':
            return 25
          case 'orderCsPaymentAmountDaily':
            return 26
          case 'orderTtPaymentAmountDaily':
            return 27
          case 'orderPdPaymentAmountDaily':
            return 28
          case null:
            return undefined
        }
      }
    },
    getUserDetailSortName() {
      return (name) => {
        switch (name) {
          case 'registerDate':
            return 1
          case 'bindStoreTotal':
            return 2
          case 'publishStoreTotal':
            return 3
          case 'publishListingTotal':
            return 4
          case 'orderStoreTotal':
            return 5
          case 'orderTotal':
            return 6
          case 'orderAmountTotal':
            return 7
          case null:
            return undefined
        }
      }
    }
  },
  created() {
    this.getUserTotalReport()
    this.getUserDetailReport()
    this.getUserInfoSelect()
    this.getAllUserGroup()
    this.getBehaviorConfig()
  },
  methods: {
    getAllUserGroup() {
      API.getAllUserGroup().then(res => {
        this.group = res.data
      })
    },
    //数据导出
    importExportFile() {
      API.importExportFile(this.exportForm).then(() => {
        this.$message.success('数据导出成功,请前往导入导出中心查看进度')
      })
    },

    sliceString(str) {
      str = str.toString()
      return str.slice(0, 4) + '-' + str.slice(4, 6) + '-' + str.slice(6)

    },

    //用户概况导出
    exportUserTotal() {
      let form = {
        periodEnd: this.userTotalForm.periodEnd,
        periodStart: this.userTotalForm.periodStart
      }
      this.exportForm = {
        fileType: 2,
        taskType: 2,
        condition: JSON.stringify(form)
      }
      this.importExportFile()
    },
    exportOrderDetail() {
      let form = {
        periodEnd: this.sliceString(this.userTotalForm.periodEnd),
        periodStart: this.sliceString(this.userTotalForm.periodStart)
      }
      this.exportForm = {
        fileType: 2,
        taskType: 8,
        condition: JSON.stringify(form)
      }
      this.importExportFile()
    },

    //用户明细导出
    exportDetailTotal() {
      let form = {
        userGroup: this.userDetailForm.userGroup,
        isAuthentication: this.userDetailForm.isAuthentication,
        userManager: this.userDetailForm.userManager,
        paramType: this.userDetailForm.paramType,
        paramStart: this.userDetailForm.paramStart,
        paramEnd: this.userDetailForm.paramEnd,
        registerDateStart: this.userDetailForm.registerDateStart,
        registerDateEnd: this.userDetailForm.registerDateEnd,
        email:this.userDetailForm.email,
        fullName:this.userDetailForm.fullName,
      }
      this.exportForm = {
        fileType: 2,
        taskType: 3,
        condition: JSON.stringify(form)
      }
      this.importExportFile()
    },

    //获取用户概况
    getUserTotalReport() {
      this.userTotalForm.periodStart = dateFormat(this.registerDate[0], 'yyyy-MM-dd').replace(/-/g, '') || dateFormat(Date.now() - 30 * 24 * 3600000, 'yyyy-MM-dd').replace(/-/g, '')
      this.userTotalForm.periodEnd = dateFormat(this.registerDate[1], 'yyyy-MM-dd').replace(/-/g, '') || dateFormat(Date.now() - 1, 'yyyy-MM-dd').replace(/-/g, '')
      API.getUserTotalReport(this.userTotalForm).then(res => {
        this.userList = res.data.vo.list || []
        this.userData = res.data.vo
        this.total = res.data.total
        this.userData.modifyDate = dateFormat(res.data.vo.modifyDate)
        this.$tableScrollTop()
      })
    },
    timeFormat(time) {
      return dateFormat(time)
    },

    //对接人列表
    getUserInfoSelect() {
      API.getUserInfoSelect(this.roleForm).then(res => {
        this.userManager = res.data
      })
    },

    //获取用户明细
    getUserDetailReport() {
      let userDetailForm=this.userDetailForm
      if (this.filterValue) {
        switch (+this.filterType) {
          case 1:
            userDetailForm.fullName = this.filterValue
            userDetailForm.email=undefined
            break
          case 2:
            userDetailForm.email = this.filterValue
            userDetailForm.fullName=undefined
            break
        }
      }else{
        userDetailForm.email=undefined
        userDetailForm.fullName=undefined
      }
      API.getUserDetailReport(userDetailForm).then(res => {
        this.userDetailList = res.data.list || []
        this.detailTotal = res.data.total
        this.userdetailModifyDate = dateFormat(res.data.modifyDate)
        res.data.modifyDate = dateFormat(res.data.modifyDate)
        this.userDetailList.forEach(item => {
          item.registerDate = dateFormat(item.registerDate, 'yyyy-MM-dd')
        })
      })
    },
    changeFilterType(){
      this.filterValue=''
    },

    changeType(){
      this.initPage()
    },

    //时间筛选用户概览
    handleDatePick(value) {
      if (value && value.length === 2) {
        this.userTotalForm.periodStart = dateFormat(value[0], 'yyyy-MM-dd').replace(/-/g, '')
        this.userTotalForm.periodEnd = dateFormat(value[1], 'yyyy-MM-dd').replace(/-/g, '')
        this.resetPage()
      } else {
        this.$nextTick(() => {
          this.registerDate = [Date.now() - 29 * 24 * 3600000, Date.now()]
          this.$forceUpdate()
          this.resetPage()
        })
      }
    },
    resetPage() {
      this.userTotalForm.pageNumber = 1
      this.getUserTotalReport()
    },
    //用户概览分页
    pageChange(page) {
      this.userTotalForm.pageNumber = page
      this.getUserTotalReport()
    },

    handleTotalSizeChange(size) {
      this.userTotalForm.pageSize = size
      this.getUserTotalReport()
    },

    //时间筛选用户明细
    handleDetailDatePick(value) {
      if (value && value.length === 2) {
        this.userDetailForm.registerDateStart = value[0]
        this.userDetailForm.registerDateEnd = value[1]
      } else {
        this.userDetailForm.registerDateStart = undefined
        this.userDetailForm.registerDateEnd = undefined
      }
      this.getUserDetailReport()
    },

    initPage() {
      this.userDetailForm.pageNumber = 1
      this.getUserDetailReport()
    },
    initPageByRange() {
      if (this.userDetailForm.paramStart !== undefined && this.userDetailForm.paramEnd !== undefined) {
        this.initPage()
      }
    },

    //用户明细分页
    DetailPageChange(page) {
      this.userDetailForm.pageNumber = page
      this.getUserDetailReport()
    },
    handleDetailSizeChange(size) {
      this.userDetailForm.pageSize = size
      this.getUserDetailReport()
    },
    //用户概览排序
    sortTotalTable({ prop, order }) {
      this.userTotalForm.sortType = this.getSortType(order)
      this.userTotalForm.sortName = this.getUserTotalSortName(prop)
      this.resetPage()
    },

    //用户明细排序
    sortDetailTable({ prop, order }) {
      this.userDetailForm.sortType = this.getSortType(order)
      this.userDetailForm.sortName = this.getUserDetailSortName(prop)
      this.initPage()
    },
    handleCheckAllChange(val) {
      this.checkList = val ? this.columnTitles.map(item => item.value) : []
      this.isIndeterminate = false;
    },
    handleCheckedCitiesChange(value) {
      let checkedCount = value.length;
      this.checkAll = checkedCount === this.columnTitles.length;
      this.isIndeterminate = checkedCount > 0 && checkedCount < this.columnTitles.length;
    },
    showDialog() {
      this.visible = true,
      this.checkList = this.columns.map(item => item.value)
      this.backUpColumn = _.cloneDeep(this.checkList)
    },
    close() {
      this.checkList = _.cloneDeep(this.backUpColumn)
      this.visible = false
      let checkedCount = this.checkList.length;
      this.checkAll = checkedCount === this.columnTitles.length;
      this.isIndeterminate = checkedCount > 0 && checkedCount < this.columnTitles.length;
    },

    save() {
      this.columns = _.cloneDeep(this.columnTitles).filter(item => this.checkList.includes(item.value))
      // 获取选中的值
      this.selected = _.cloneDeep(this.columns).map(item => item.title)
      this.setBehaviorConfig()
      this.userTotalForm.showFields = [...this.checkList, 'period', 'activeUserDaily', 'registerDaily']
      if (this.tabName === '1') {
        this.getUserTotalReport()
      } else {
        this.getUserDetailReport()
      }
      this.backUpColumn = this.checkList
      this.visible = false
      this.$forceUpdate()
    },
    getBehaviorConfig() {
      // 获取用户概览的列表字段显示
      API.getBehaviorConfig(4).then((res) => {
        if (!res.data) return
        this.checkList = res.data.content
        this.columns = _.cloneDeep(this.columnTitles).filter(item => this.checkList.includes(item.title))
        this.configId = res.data.id
      })
    },
    setBehaviorConfig() {
      const params = {
          type: 4,
          content: JSON.stringify(this.selected),
          id: this.configId
      }
      API.setBehaviorConfig(params)
    }
  }
}
</script>

<style lang="scss" scoped>
.content {
  height: 100%;
  background: #ffffff;
  padding: 12px 12px 0;
  .filter {
    padding: 12px;
    & > div {
      margin-left: 12px;
    }
    /deep/.el-input-group {
      width: 300px;
    }
    /deep/.el-input-group__prepend {
      width: 100px;
    }
  }
}
.range-num {
  display: inline-block;
  margin-right: 16px;
}
.update-time {
  display: inline-block;
  margin: 0 16px;
}

.avatar {
  width: 178px;
  height: 178px;
  object-fit: cover;
}
.uploader-icon {
  font-size: 28px;
  color: #8c939d;
  width: 178px;
  height: 178px;
  line-height: 178px;
  text-align: center;
  border: 1px dashed #d9d9d9;
  border-radius: 6px;
}
/deep/.el-range-separator {
  min-width: 20px;
}
.info-list {
  height: 50px;
  padding-left: 22px;
  color: #99c41c;
  font-size: 16px;
  span {
    display: inline-block;
    margin-right: 16px;
  }
}
</style>>
